<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import serviciosHigieneAPI from "@/services/standards/serviciosHigiene/serviciosHigieneAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import { required } from "vuelidate/lib/validators";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.8 Servicios de higiene",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "3.1.8 Servicios de higiene",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Servicios de higiene",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/servicios-higiene`,
        },

        {
          text: "Editar",
          active: true,
        },
      ],

      submitted: false,
      lista: [],
      file: null,
      itemData: null,
      acta: null,

      company: this.$store.getters["company/getCompany"],

      servicios: {
        hygiene_service: null,
        file: null,
        other: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  validations: {
    file: {
      required,
    },
    servicios: {
      hygiene_service: {
        required,
      },


    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(30)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.servicios.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.8/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.8/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.servicios.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getIdentification() {
      serviciosHigieneAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.servicios = {
            hygiene_service: response.data.hygiene_service,
            file: response.data.file,
            other: response.data.other,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      try {
        this.submitted = true
        this.loading = true
        let response = await this.uploadDocument();
        if (response) {
          serviciosHigieneAPI
            .update(this.$route.params.id, {
              hygiene_service: this.servicios.hygiene_service,
              file: this.servicios.file,
              other: this.servicios.other,
              companies_id: this.servicios.companies_id,
            })
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 30,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Informacion actualizada con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    this.$router.go(-1);
                  }, 3000);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getIdentification();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Servicio de higiene" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="servicios.hygiene_service" v-on:change="getDataTraining()">
                      <b-form-select-option value="Disposición de agua potable">
                        Disposición de agua potable
                      </b-form-select-option>
                      <b-form-select-option value="Manejo de aguas residuales">
                        Manejo de aguas residuales
                      </b-form-select-option>
                      <b-form-select-option value="Cantidad de servicios sanitarios">
                        Cantidad de servicios sanitarios
                      </b-form-select-option>
                      <b-form-select-option value="Dotación de servicios sanitarios">
                        Dotación de servicios sanitarios
                      </b-form-select-option>
                      <b-form-select-option value="Otros ¿cuáles?">
                        Otros ¿cuáles?
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Evidencia" label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="file" ref="file" name="file"
                      browse-text="Buscar" :placeholder="servicios.file
                        ? getFile(servicios.file)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div v-if="servicios.hygiene_service === 'Otros ¿cuáles?'" class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Otro ¿Cuál?" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="servicios.other" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
